module.exports = __webpack_public_path__ + "img/public/SiteIcons/locationIdea.svg?200cee98";